import type { SegmentGroup } from '@app/model/bi/Bi';

// A group on the editor board: id = the saved id, null for a new group.
export type BoardGroup = { id: number | null, title: string, segments: string[] };

// A PMS segment name as the backend keys an assignment (BiService.segmentKey): case and spaces ignored.
export const keyOf = (name: string) => name.toLowerCase().replace(/\s+/g, '');

const sameSegments = (a: string[], b: string[]) => {
	const left = new Set(a.map(keyOf)), right = new Set(b.map(keyOf));
	return left.size === right.size && [...left].every(key => right.has(key));
};

// ROO2-244: the board has changes when it differs from the saved groups. The groups are compared in board order (the
// position is stored) by id, trimmed title and the set of segment keys; the order of the segments inside a group is
// not stored, so it is no change.
export const segmentGroupsChanged = (board: BoardGroup[], saved: SegmentGroup[]): boolean =>
	board.length !== saved.length || board.some((group, i) => group.id !== saved[i].id
		|| group.title.trim() !== saved[i].title.trim() || !sameSegments(group.segments, saved[i].segments));
